<template>
  <v-col cols="12" class="v-custom-consent">
    <div v-if="field.title" class="label mb-4" style="color: #000; font-size: 15px;">
      <b>{{field.title_not_to_trad ? field.title : $t(field.title)}}</b>
      <span v-if="field.props && field.props.required" style="color:red">&nbsp;*</span>
    </div>
    <v-row dense>
      <v-col cols="12">
        <v-alert color="warning" v-if="noConsentSetted" dense text border="left">
          <span v-html="$t('noConsentSettedAlert')"></span>
        </v-alert>
      </v-col>
      <v-col cols="6" v-for="(consentValue, key, idx) in model[fieldName]" :key="key" class="px-6 mb-4">
        <div class="d-flex align-center justify-space-between py-0">
          <span class="mr-4">{{ $t(key) }}</span>
          <v-btn-toggle
            v-model="model[fieldName][key]"
            mandatory
            dense
        >
            <v-btn value="denied" class="denied-btn square" style="border-radius:5px 0 0 5px !important;">
                <v-icon small>$times_s</v-icon>
            </v-btn>
            <v-btn value="unknown" class="unknown-btn square" style="border-radius:0 !important;">
                <v-icon small>$question_r</v-icon>
            </v-btn>
            <v-btn value="granted" class="granted-btn square" style="border-radius:0 5px 5px 0 !important;">
                <v-icon small>$checkn_s</v-icon>
            </v-btn>
        </v-btn-toggle>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: "VCustomConsent",
  props: ["model", "fieldName", "field"],
  computed: {
    noConsentSetted() {
      if(this.model['id']) return false;
      
      for (const key in this.model[this.fieldName]) {
        if (this.model[this.fieldName][key] !== 'unknown') {
          return false;
        }
      }
      return true;
    }
  },
};
</script>

<style scoped>
.denied-btn {
    &.v-btn--active {
        background-color: #d9544f !important;
        color: #fff !important;
        .v-icon {
            color: #fff !important;
        }
    }
}

.unknown-btn {
    &.v-btn--active {
        background-color: #f0f0f0 !important;
        color: #000 !important;
        .v-icon {
            color: #000 !important;
        }
    }
}

.granted-btn {
    &.v-btn--active {
        background-color: #5bb85d !important;
        color: #fff !important;
        .v-icon {
            color: #fff !important;
        }
    }
}

.v-custom-consent .d-flex {
  border-bottom: 1px solid #f0f0f0;
}
.v-custom-consent .d-flex:last-child {
  border-bottom: none;
}
</style>
